// FAQ answers below were drafted from internal context (use-plans.ts,
// listing-level.tsx, account-set-default-listing-level.tsx) and are flagged
// for marketing review before launch (BHT-5937).

export interface Faq {
  id: number;
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    id: 1,
    question: 'Do I have to upgrade all my properties?',
    answer:
      'No. Boost tiers apply per listing. Pick a default tier for your account and override individual listings whenever you want — boost a single high-value property, a handful in a competitive market, or your whole portfolio.',
  },
  {
    id: 2,
    question: 'Can I change tiers anytime?',
    answer:
      'Yes. Move listings up or down between Standard, Boost, Boost Plus, and Boost Max at any time from your billing settings. Changes take effect on your next billing cycle and there are no contracts to cancel.',
  },
  {
    id: 3,
    question: 'How quickly will I see results?',
    answer:
      'Boosted listings start receiving the higher exposure tier as soon as the upgrade is live. Search ranking and impressions reflect the new placement immediately; bookings depend on traveler demand, your photos, pricing, and reviews, so most hosts see the impact in their next booking window.',
  },
  {
    id: 4,
    question: 'Will this get me more reservations?',
    answer:
      'Boosted Listings drive more visibility to your properties. What happens next is up to you. Make sure your pricing is competitive, your photos are compelling, and your descriptions answer traveler questions. Exposure gets attention. Quality gets bookings.',
  },
  {
    id: 5,
    question: 'How is exposure calculated?',
    answer:
      'Each tier multiplies the number of search-result impressions a listing earns versus the Standard baseline. Boost gives roughly 3.4x, Boost Plus 6.6x, and Boost Max 11.8x more exposure across eligible searches in your market.',
  },
];
